<template>
  <TableLayout :permissions="['meihui:privateDiary:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="用户ID"><el-input v-model="searchForm.userId" placeholder="用户ID" @keypress.enter.native="search" /></el-form-item>
      <el-form-item label="标题"><el-input v-model="searchForm.title" placeholder="标题" @keypress.enter.native="search" /></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.opera.open('新建私密日记')"" icon="el-icon-plus" v-permissions="['meihui:privateDiary:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:privateDiary:delete']">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="userId" label="用户ID" width="100" show-overflow-tooltip />
        <el-table-column prop="title" label="标题" width="150" show-overflow-tooltip />
        <el-table-column prop="moodLabel" label="心情" width="80" show-overflow-tooltip />
        <el-table-column prop="weather" label="天气" width="80" show-overflow-tooltip />
        <el-table-column prop="region" label="地区" width="100" show-overflow-tooltip />
        <el-table-column prop="diaryTime" label="日记时间" width="180" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.opera.open('编辑私密日记', row)"" icon="el-icon-edit" v-permissions="['meihui:privateDiary:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:privateDiary:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
    <operaprivateDiaryWindow ref="opera" @success="handlePageChange" />
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operaprivateDiaryWindow from './operaprivateDiaryWindow'
export default {
  name: 'PrivateDiary', extends: BaseTable, components: { TableLayout, Pagination, operaprivateDiaryWindow },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: '私密日记', api: '/rentHouse/privateDiary', 'field.id': 'id', 'field.main': 'title' })
    this.search()
  }
}
</script>